import React from 'react';
import { Row } from "../../layout";
import { Text } from "../../text";
import { DateMarkerLegendLi } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";

var DateMarkerLegendEntry = function DateMarkerLegendEntry(_ref) {
  var markerExample = _ref.markerExample,
      descriptionText = _ref.descriptionText;
  return ___EmotionJSX(DateMarkerLegendLi, null, ___EmotionJSX(Row, {
    gridGap: "S200",
    alignItems: "center"
  }, markerExample, ___EmotionJSX(Text, {
    fontSize: "T100",
    color: "neutral70"
  }, descriptionText)));
};

DateMarkerLegendEntry.displayName = 'DateMarkerLegendEntry';
export default DateMarkerLegendEntry;